import React from 'react'
import { Table } from 'react-bootstrap'
import { parseFleetName } from '../../utils/utils';

function ShipList({data, portData}) {

    const ships = Object.entries(data.number_of_ships).map(el=>({number: el[1], ...parseFleetName(el[0], portData)}));

  return (
    <div>
        <div className='mb-2'>
            The following ships were used in the simulation:
            </div>
        <Table striped bordered hover>
      <thead>
        <tr>
          <th>Ship type</th>
          <th>Port of origin</th>
          <th>Port of destination</th>
          <th>Number of ships</th>
        </tr>
      </thead>
      <tbody>
        {ships.map((el) => (
        <tr key={el.fleet}>
          <td>{el.shiptype}</td>
          <td>{el.portA}</td>
          <td>{el.portB}</td>
          <td>{el.number}</td>
        </tr>

        ))}
      </tbody>
    </Table>
    </div>
  )
}

export default ShipList